import React, { useState } from 'react';
import { Input, Form, FormGroup, Button, Label } from 'reactstrap';
import AuthService from '../Services/AuthService';
import { useToasts } from 'react-toast-notifications';
import { withTranslation } from 'react-multi-lang';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faUser } from "@fortawesome/free-solid-svg-icons";

const LoginComponent = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { addToast } = useToasts();
    const authService = new AuthService();
    
    const dologin = (e) => {
        e.preventDefault();
        setIsLoading(true);
        authService.login(username, password).then(l => {
            setIsLoading(false);
            addToast("Επιτυχής είσοδος, αναμένετε ανακατεύθυνση", { appearance: 'success', autoDismiss: true, autoDismissTimeout: 5000 });
        }).catch(e => {
            setIsLoading(false);
            addToast(e, { appearance: 'error', autoDismiss: true, autoDismissTimeout: 5000 });
        });
    };
    
    return (
        <div className="login-wrapper">
            <div className="login-card">
                <div className="login-logo-container">
                    <img src="/logo512.png" alt="Nordia Logo" />
                    <h3 className="login-title">Quarry Management</h3>
                    <p className="login-subtitle">Συνδεθείτε για πρόσβαση στον κεντρικό πίνακα</p>
                </div>
                <Form onSubmit={dologin}>
                    <FormGroup className="mb-3">
                        <Label className="d-flex align-items-center gap-2">
                            <FontAwesomeIcon icon={faUser} className="text-muted small" />
                            <span>Username</span>
                        </Label>
                        <Input 
                            type="text" 
                            placeholder="Εισάγετε όνομα χρήστη"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)} 
                            required
                        />
                    </FormGroup>
                    <FormGroup className="mb-4">
                        <Label className="d-flex align-items-center gap-2">
                            <FontAwesomeIcon icon={faLock} className="text-muted small" />
                            <span>Password</span>
                        </Label>
                        <Input 
                            type="password" 
                            placeholder="Εισάγετε κωδικό πρόσβασης"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)} 
                            required
                        />
                    </FormGroup>
                    <Button color="primary" block className="w-100 py-2 font-weight-bold" disabled={isLoading}>
                        {isLoading ? 'Σύνδεση...' : 'Είσοδος'}
                    </Button>
                </Form>
            </div>
        </div>
    );
};

export default withTranslation(LoginComponent);